module.exports = __webpack_public_path__ + "static/study-f603524b77702d5bffe9dc197a7b0516.jpg";